import React from "react";
import { Item, Parent } from "./TransactionTabRow";
import { AddFlex, CustomText, NumberAndWhatsAppIcon } from "./reusableStyles";
import { primaryActionColor } from "../utils/constants";
import { format } from "date-fns";
import {
  BODHI_LOGIN,
  Currency,
  formatPrice,
  handleOpenInNew,
} from "../utils/utils";
import { Mail, OpenInNew } from "@mui/icons-material";

function MetricsRow({ client, index, headerList }) {
  console.log(client);
  const isBodhiClient = () => {
    return client?.domain === BODHI_LOGIN;
  };
  return (
    <>
      <Parent>
        {/* <input
          type="checkbox"
          sx={{
            padding: "0px",
            color: primaryActionColor,
            "&.Mui-checked": {
              color: primaryActionColor,
            },
          }}
          //   checked={selectedOrders.includes(sale.data.id)}
          //   onChange={(e) => {
          //     headerCheckboxClicked(sale.data.id);
          //   }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        /> */}
        <Item
          justify="center"
          style={{ marginLeft: "10px", gap: "5px" }}
          percent={headerList[0][0]}
          alignItems="center"
        >
          {index + 1}
        </Item>
        <Item
          justify="flex-start"
          style={{ marginLeft: "10px", gap: "5px" }}
          percent={headerList[1][0]}
          alignItems="center"
        >
          <AddFlex flexDirection="column">
            <AddFlex>
              <CustomText fontSize="14px" color="#101828">
                {client?.userName}{" "}
              </CustomText>
              <OpenInNew
                sx={{ fontSize: "18px" }}
                onClick={() => {
                  handleOpenInNew(`https://${client?.userName}.growezy.club`);
                }}
              />
              <a
                href={`mailto:${client.userEmail}`}
                style={{
                  textDecoration: "none",
                  color: "#101828",
                  margin: 0,
                  padding: 0,
                }}
              >
                <Mail sx={{ fontSize: "18px" }} />
              </a>
            </AddFlex>
            {client?.UserAdditionalDetails.userPhoneNumber && (
              <NumberAndWhatsAppIcon
                number={client?.UserAdditionalDetails.userPhoneNumber}
              />
            )}
          </AddFlex>
        </Item>
        <Item justify="center" percent={headerList[2][0]}>
          <AddFlex flexDirection="column" justify="center" alignItems="center">
            <CustomText fontSize="14px" color="#020817">
              {client?.UserAdditionalDetails.createdAt &&
                format(
                  new Date(client?.UserAdditionalDetails.createdAt),
                  "dd/MM/yyyy"
                )}
            </CustomText>
            <CustomText fontSize="14px" color="#64748B">
              {client?.UserAdditionalDetails.createdAt &&
                format(
                  new Date(client?.UserAdditionalDetails.createdAt),
                  "hh:mm a"
                )}
            </CustomText>
          </AddFlex>
        </Item>
        <Item justify="center" percent={headerList[3][0]}>
          <CustomText color="black">
            {client?.publishedStats.withZeroRevenue} /{" "}
            {client?.unpublishedStats.withZeroRevenue}
          </CustomText>
        </Item>

        <Item percent={headerList[4][0]}>
          <CustomText color={isBodhiClient() ? "#FF9102" : "#020817"}>
            <CustomText color="black">
              {client?.publishedStats.total} /{" "}
              {formatPrice(client?.publishedStats.totalPublishedRevenue, "INR")}
            </CustomText>
          </CustomText>
        </Item>
        <Item percent={headerList[5][0]}>
          {formatPrice(client.clientRevenue, Currency.INR)}{" "}
        </Item>
        {/* <Item percent={headerList[4][0]}>
          {formatPrice(client.clientRevenue, Currency.INR)}{" "}
        </Item>
        <Item percent={headerList[5][0]}>
          {formatPrice(client.totalSettled, Currency.INR)}
        </Item>
        <Item percent={headerList[6][0]}>
          {formatPrice(client.totalPending, Currency.INR)}
        </Item>
        <Item percent={headerList[7][0]}>
          {" "}
          {client.UserAdditionalDetails.commission.percent * 100}% or{" "}
          {formatPrice(
            client.UserAdditionalDetails.commission.maxCom,
            Currency.INR
          )}
        </Item> */}

        {/* <Item percent={headerList[7][0]}></Item> */}
      </Parent>
      <div
        style={{ backgroundColor: "#ECECEC", width: "100%", height: "1px" }}
      ></div>
    </>
  );
}

export default MetricsRow;
